import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  p {
    text-align: center;
    margin-top: 2rem;
    font-size: 1.5rem;
    font-weight: 500;
  }
`;